<mat-accordion multi="true">
  <mat-expansion-panel id="newErasePanel" [expanded]="true">
    <mat-expansion-panel-header class="blueHeader">
      {{"NEW_ERASER"|translate}}
    </mat-expansion-panel-header>

    <div class="panel">
      <div id="newEraseForm" class="panelContent">
        <div id="datePickerStartDateCont" style="display: flex; align-items: center">
          <input id="datePickerStartDate"
                 placeholder="Choose a start date"
                 matInput
                 [matDatepicker]="pickerDateStart"
                 [(ngModel)]="dateStartPicker">
          <mat-datepicker-toggle matSuffix
                                 [for]="pickerDateStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerDateStart style="display: block"></mat-datepicker>
          <ngb-timepicker [(ngModel)]="timeStartPicker" [seconds]="true"
                          [disabled]="disabled"></ngb-timepicker>
        </div>
        <div style="margin-top: 40px">
          <div id="datePickerEndDateCont" style="display: flex; align-items: center">
            <input id="datePickerEndDate"
                   placeholder="Choose an end date"
                   matInput
                   [matDatepicker]="pickerDateEnd"
                   [(ngModel)]="dateEndPicker">
            <mat-datepicker-toggle matSuffix
                                   [for]="pickerDateEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerDateEnd style="display: block"></mat-datepicker>
            <ngb-timepicker [(ngModel)]="timeEndPicker" [seconds]="true"
                            [disabled]="disabled"></ngb-timepicker>
          </div>
        </div>
        <div style="margin-top: 20px">
                                        <textarea cols="90" rows="2" class="block" [(ngModel)]="comment"
                                                  [placeholder]="'COMMENTS' | translate"></textarea>
        </div>
      </div>
    </div>
    <div class="panelFooter">
      <button (click)="submit()"
              id="submitEraserBtn"
              class="btn btn-success">
        {{ 'VALIDATE' | translate }}
      </button>
    </div>


  </mat-expansion-panel>


  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header class="blueHeader">
      {{"ERASER_TABLE"|translate}}
    </mat-expansion-panel-header>
    <div class="panel">
      <!--<div class="panelHeader">-->
      <!--Offset table-->
      <!--</div>-->
      <div class="panelContent">
        <table>
          <thead>
          <tr class="tableLabels">
            <th style="width: 170px">{{ 'DATE_START' | translate }}</th>
            <th style="width: 170px">{{ 'DATE_END' | translate }}</th>
            <th>{{ 'COMMENTS' | translate }}</th>
            <th style="width: 260px"></th>
          </tr>
          </thead>
          <tbody *ngIf="selectedLocationDataProcessMeasures">
          <tr *ngFor="let eraser of selectedLocationDataProcessMeasures, let i = index">
            <th *ngIf="!eraser.selected">{{eraser.dateStartToDisplay}}</th>
            <th *ngIf="eraser.selected" class="datePickerInputChange"
                id="datePickerInputDateStartChangeCont" style="align-items: center">
              <input style="width: 70% !important;"
                     id="datePickerInputDateStartChange" matInput
                     [matDatepicker]="picker"
                     placeholder="Choose a date"
                     [(ngModel)]="dateStartPickerPatcheEraser">
              <mat-datepicker-toggle matSuffix
                                     [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <ngb-timepicker [(ngModel)]="timeStartPickerPatcheEraser"
                              [seconds]="true"
                              [disabled]="disabled"></ngb-timepicker>
            </th>
            <th *ngIf="!eraser.selected">{{eraser.dateEndToDisplay}}</th>
            <th *ngIf="eraser.selected" id="datePickerInputDateEndChangeCont"
                class="datePickerInputChange" style="align-items: center">
              <input style="width: 70% !important;"
                     id="datePickerInputDateEndChange" matInput
                     [matDatepicker]="picker"
                     placeholder="Choose a date"
                     [(ngModel)]="dateEndPickerPatcheEraser">
              <mat-datepicker-toggle matSuffix
                                     [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <ngb-timepicker [(ngModel)]="timeEndPickerPatcheEraser"
                              [seconds]="true"
                              [disabled]="disabled"></ngb-timepicker>
            </th>
            <th class="comments">
              <span *ngIf="!eraser.selected">{{eraser.comment}}</span>
              <input class="inputLarge"
                     #offsetComment
                     *ngIf="eraser.selected"
                     [value]="eraser.comment || ''"
                     (input)="eraser.new_comment = offsetComment.value">
            </th>
            <th [ngClass]="eraser.selected ? 'submitUpdateCont' : ''">
              <div class="updateButtonsCont"
                   *ngIf="!eraser.selected">
                <button class="btn btn-info"
                        (click)="setDatePatchErase(eraser.startDate, eraser.endDate, i)"
                        [ngbTooltip]="'UPDATE' | translate">
                  <fa-icon [icon]="faPen">
                  </fa-icon>
                </button>
                <button class="btn btn-warning"
                        (click)="deleteDataProcessMeasures(eraser.id)"
                        [ngbTooltip]="'DELETE' | translate">
                  <fa-icon [icon]="faTrash">
                  </fa-icon>
                </button>
              </div>
              <div *ngIf="eraser.selected">
                <button class="btn btn-warning"
                        (click)="eraser.selected = undefined"
                        class="bootstrapStyle btn btn-primary offsetStyleButt deleteOffsetButt">
                  {{ 'CANCEL' | translate }}
                </button>
                <button class="bootstrapStyle btn btn-warning"
                        (click)="patchDataProcessMeasures(eraser)">
                  {{ 'VALIDATE' | translate }}
                </button>
              </div>
            </th>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

</mat-accordion>
